// Grouped multi-role picker for User Management. Guest is held alone, so
// ticking it clears the rest and ticking anything else clears Guest. The
// backend checks every rule again (role-admin.service.ts assertEndState).

import React from 'react';
import { GUEST_ROLE_ID, ROLE_GROUP_LABELS, ROLE_GROUP_ORDER, Role } from '../../services/roles';

interface RolePickerProps {
  roles: Role[];
  value: string[];
  onChange: (roleIds: string[]) => void;
}

export function nextRoleSelection(current: string[], roleId: string): string[] {
  if (current.includes(roleId)) return current.filter((id) => id !== roleId);
  if (roleId === GUEST_ROLE_ID) return [GUEST_ROLE_ID];
  return [...current.filter((id) => id !== GUEST_ROLE_ID), roleId];
}

export const RolePicker: React.FC<RolePickerProps> = ({ roles, value, onChange }) => (
  <div className="flex flex-col gap-3 p-3 bg-slate-50/60 border border-[#e2e8f0] rounded-xl">
    {ROLE_GROUP_ORDER.map((group) => {
      const list = roles.filter((r) => r.group === group);
      if (!list.length) return null;
      return (
        <div key={group}>
          <p className="text-[11px] font-bold text-primary tracking-widest uppercase px-2.5 mb-1">{ROLE_GROUP_LABELS[group]}</p>
          <div className="grid grid-cols-2 gap-1">
            {list.map((role) => {
              const checked = value.includes(role.id);
              return (
                <label key={role.id}
                  className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg cursor-pointer transition-colors ${checked ? 'bg-primary/5' : 'hover:bg-slate-100'}`}>
                  <input type="checkbox" checked={checked} onChange={() => onChange(nextRoleSelection(value, role.id))}
                    className="w-4 h-4 accent-primary rounded" />
                  <span className={`text-sm ${checked ? 'font-semibold text-navy' : 'text-slate-500'}`}>{role.name}</span>
                </label>
              );
            })}
          </div>
        </div>
      );
    })}
  </div>
);
